import {
    setAdtaDeviceDetails,
    fetchAdtaDeviceDetails,
    setAdtaDeviceConfigDetails,
    deleteAdtaDeviceDetails,
    deleteAdtaDeviceConfigDetails,
    setAdtaDeviceTestPackageDetails, deleteAdtaDeviceTestPackageDetails, updateAdtaDeviceDetails
} from "../network/AdtaDeviceOverviewNetworkAPI";

export const AdtaDeviceOverviewReducer = (state, action) => {
    switch (action.type) {
        case "RECEIVE_DATA":
            return {...state, ...action.data, loadingOverview: false}
        case "LOAD_VIEW":
            fetchAdtaDeviceDetails(action.data.dispatcher)
            return state
        case "ADD_CONFIG_DATA":
            setAdtaDeviceConfigDetails(action.data.dispatcher, action.data.sorterConfig, action.data.mac)
            return state
        case "ADD_TEST_PACKAGE_DATA":
            setAdtaDeviceTestPackageDetails(action.data.dispatcher, action.data.sorterTestPackage, action.data.mac)
            return state
        case "ADD_DEVICE_DATA":
            setAdtaDeviceDetails(action.data.dispatcher, action.data.stateValues)
            return state
        case "UPDATE_DEVICE_DATA":
            updateAdtaDeviceDetails(action.data.dispatcher, action.data.stateValues)
            return state
        case "DELETE_DEVICE_DATA":
            deleteAdtaDeviceDetails(action.data.dispatcher, action.data.mac)
            return state
        case "DELETE_DEVICE_CONFIG_DATA":
            deleteAdtaDeviceConfigDetails(action.data.dispatcher, action.data.mac, action.data.bayId)
            return state
        case "DELETE_DEVICE_TEST_PACKAGE_DATA":
            deleteAdtaDeviceTestPackageDetails(action.data.dispatcher, action.data.mac, action.data.scannables)
            return state
        case "SORT_DATA":
            return {...state, sortPref: action.data}
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/components/devicemanagement/adtadevice/reducer/AdtaDeviceOverviewReducer.js